export enum NatureOfComplaintInternational {
  ORDER_ENTRY = 'Order Entry',
  ITEM_OR_QUANTITY = 'Item or Quantity',
  PRODUCT_DATING = 'Product Dating',
  PRODUCT_DAMAGE = 'Product Damage',
  PRODUCT_TEMPERATURE = 'Product Temperature',
  DELIVERY = 'Delivery',
  DOCUMENTATION = 'Documentation',
  INVOICE_ERROR = 'Invoice Error',
  QUALITY = 'Quality',
}
